"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AccessibleRoomTypeOptionsContainer;
var _api = require("@whitbread-eos/api");
var _nextI18next = require("next-i18next");
var _AccessibleRoomTypeOptions = _interopRequireDefault(require("./AccessibleRoomTypeOptions.component"));
var _jsxRuntime = require("react/jsx-runtime");
function AccessibleRoomTypeOptionsContainer(_ref) {
  var {
    data,
    accessibleRoomSelections,
    roomTypeSelections,
    onRoomTypeSelection,
    onAccessibleRoomSelection,
    hotelInventoryResponse,
    selectedPMSRoomTypes
  } = _ref;
  var {
    t
  } = (0, _nextI18next.useTranslation)(['common']);
  if (!data) return null;
  var rooms = data.map(room => {
    var accessibleRoomTypes = room.rooms.map(info => info !== null && info !== void 0 && info.specialRequests.includes('WETR') || info !== null && info !== void 0 && info.specialRequests.includes('LOWB') ? _api.ROOM_TYPE.STANDARD_ACCESSIBLE : info !== null && info !== void 0 && info.specialRequests.includes('BFRE') ? _api.ROOM_TYPE.BARRIER_FREE : undefined).filter(Boolean);
    var pmsRoomTypes = room.rooms.reduce((acc, info) => {
      if (info !== null && info !== void 0 && info.specialRequests.includes('WETR') || info !== null && info !== void 0 && info.specialRequests.includes('LOWB')) acc.str.push(info === null || info === void 0 ? void 0 : info.pmsRoomType);
      if (info !== null && info !== void 0 && info.specialRequests.includes('BFRE')) acc.bfr.push(info === null || info === void 0 ? void 0 : info.pmsRoomType);
      return acc;
    }, {
      str: [],
      bfr: []
    });
    var mappedRoomTypes = room.rooms.map(_ref2 => {
      var {
        pmsRoomType
      } = _ref2;
      return pmsRoomType;
    });
    return {
      roomTypes: [...new Set(room.rooms.map(info => _api.ROOM_TYPE_TO_DISPLAY_TEXT_MAPPING[info === null || info === void 0 ? void 0 : info.pmsRoomType] ? t(_api.ROOM_TYPE_TO_DISPLAY_TEXT_MAPPING[info === null || info === void 0 ? void 0 : info.pmsRoomType]) : ''))],
      adults: room.adults,
      children: room.children,
      accessibleRoomTypes: accessibleRoomTypes.length ? accessibleRoomTypes : undefined,
      pmsRoomTypes,
      mappedRoomTypes
    };
  });
  return (0, _jsxRuntime.jsx)(_AccessibleRoomTypeOptions.default, {
    rooms: rooms,
    roomTypeSelections: roomTypeSelections,
    accessibleRoomSelections: accessibleRoomSelections,
    onRoomTypeSelection: onRoomTypeSelection,
    onAccessibleRoomSelection: onAccessibleRoomSelection,
    hotelInventoryResponse: hotelInventoryResponse,
    selectedPMSRoomTypes: selectedPMSRoomTypes
  });
}